import { observer } from 'mobx-react';
import React, { useCallback, useEffect, useState } from 'react';
import CorpListExcelRegisterListPopup from './corp-list-excel-register-list-popup';
import CorpListStore from './corp-list-store';

const CorpListExcelRegisterListPopupContainer = ({ setFileInfo }) => {
  // console.log('CorpListExcelRegisterListPopupContainer Load');

  const { excelRegisterList, visibleExcelRegisterListPopup } = CorpListStore;

  useEffect(() => {
    // console.log('CorpListExcelRegisterListPopupContainer > useEffect()');
  }, [excelRegisterList, visibleExcelRegisterListPopup]);

  // 법인 사용자 등록
  const onClickExcelRegister = useCallback(async () => {
    const tempExcelRegisterList = excelRegisterList.filter(
      (data) => data.RegCheck === 0 || data.RegCheck === 1
    );

    if (tempExcelRegisterList.length <= 0) {
      alert('등록가능한 사용자가 없습니다.');
      return;
    }

    let result;

    const resultArray = await Promise.all(
      tempExcelRegisterList.map(async (data) => {
        if (data.RegCheck === 0) {
          result = await CorpListStore.insertUserInfo(data);
        } else if (data.RegCheck === 1) {
          result = await CorpListStore.updateUserInfo(data);
        }

        return `${result.error ? '등록실패' : '등록성공'} : ${
          data.LineNumber
        } , ${data.Name}\n`;
      })
    );

    alert(resultArray.join(''));

    CorpListStore.setVisibleExcelRegisterListPopup(false);
    CorpListStore.setVisibleExcelRegisterFilePopup(false);
    CorpListStore.getUserList();
    setFileInfo([]);
  }, [excelRegisterList, setFileInfo]);

  if (!excelRegisterList) {
    return;
  }

  return (
    <CorpListExcelRegisterListPopup
      onHiding={() => {
        CorpListStore.setVisibleExcelRegisterListPopup(false);
        setFileInfo([]);
      }}
      onClickExcelRegister={onClickExcelRegister}
      excelRegisterList={excelRegisterList}
      visibleExcelRegisterListPopup={visibleExcelRegisterListPopup}
    />
  );
};

export default React.memo(observer(CorpListExcelRegisterListPopupContainer));
